import { all, select, call, put } from 'redux-saga/effects';
import { withOffset, selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { FetchType } from '@wix/da-shared-react/pkg/Stream/base/types';
import { getProfileOwner } from '../../selectors/users';
import { isApiError } from '@wix/da-http-client';
import { requestPuppyGruser } from '../gruserHelpers';

interface ModuleStreamConfig {
  url: string;
  schema?: any;
}

export function createModuleStreamFetcher(config: ModuleStreamConfig) {
  return function* (action) {
    const { streamId } = action;
    try {
      const [offset, limit, moduleId, profileOwner] = yield all([
        select(state => withOffset.selectors.getNextOffset(state, streamId)),
        select(state => streamSelectors.getItemsPerFetch(state, streamId)),
        select(state => streamSelectors.getStreamParam(state, streamId, 'moduleId')),
        select(getProfileOwner),
      ]);

      const response = yield call(
        requestPuppyGruser,
        {
          method: 'get',
          url: config.url,
          params: {
            username: profileOwner.user.username,
            moduleid: moduleId,
            offset,
            limit,
          },
        },
        undefined,
        'gruser'
      );

      if (!response || isApiError(response)) {
        yield put(withOffset.actions.fetchFailure({ streamId, fetchType: FetchType.Next }));
        return;
      }

      const { hasMore, nextOffset, results } = response;

      if (config.schema) {
        const { result, entities } = normalize(results, [config.schema]);
        yield put(
          withOffset.actions.fetchSuccess({
            streamId,
            hasMore,
            nextOffset,
            items: result,
            entities,
          })
        );
      } else {
        yield put(
          withOffset.actions.fetchSuccess({
            streamId,
            hasMore,
            nextOffset,
            items: results,
          })
        );
      }
    } catch {
      yield put(withOffset.actions.fetchFailure({ streamId, fetchType: FetchType.Next }));
    }
  };
}
